"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HideOnScroll = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var HideOnScroll = function HideOnScroll(props) {
  var children = props.children,
    direction = props.direction;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  var trigger = (0, _core.useScrollTrigger)({
    target: props.target || undefined
  });
  return /*#__PURE__*/_react.default.createElement(_core.Slide, {
    appear: false,
    direction: direction,
    in: !trigger
  }, children);
};
exports.HideOnScroll = HideOnScroll;